import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminCustomerDetail } from "@/types/customer"

export type AdminCustomerDetailState = {
  data: AdminCustomerDetail | null
  error: string | null
}

export const adminCustomerDetailInitialState: AdminCustomerDetailState = {
  data: null,
  error: null,
}

const slice = createSlice({
  name: "adminCustomerDetail",
  initialState: adminCustomerDetailInitialState,
  reducers: {
    setAdminCustomerDetailAction(state, { payload }: PayloadAction<AdminCustomerDetail | null>) {
      state.data = payload
      state.error = null
    },
    setAdminCustomerDetailErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const { setAdminCustomerDetailAction, setAdminCustomerDetailErrorAction } = slice.actions
export default slice.reducer
